module.exports = __webpack_public_path__ + "static/img/show.0bafcb2f.png";